/**
 * Track various Assets and Logos the user selects within the current Editor session.
 *
 * Used for History and, eventually, "recently viewed {asset}" lists.
 */

export const state = () => ({
  logos: [],
})

export const mutations = {
  /**
   * Add an item to our history
   * @param {*} state
   * @param {object} logo the Logo to add to history.
   */
  add(state, logo) {
    // Don't add the same item twice
    if (state.logos.find(item => item.logo.id === logo.id)) {
      return
    }

    let history = [...state.logos, { logo, created: Date.now() }]

    // Remove the first entry if we go over 10 items
    if (history.length > 10) {
      history.shift()
    }

    state.logos = history
  },

  /**
   * Remove all history entries.
   */
  reset(state) {
    state.logos = []
  },
}

export const getters = {
  index: ({ logos }, _getters, rootState) => {
    return logos.findIndex(
      ({ logo }) => logo.id === rootState.editor.current_logo.id
    )
  },
  /**
   * Reduce our Logo history into an Array of Icons.
   */
  icons: ({ logos }) => {
    return logos.reduce((icons, { logo }) => {
      const icon = logo?.assets?.icons?.[0] ?? logo.assets.icons.icon
      if (!!icon && !icons.find(({ id }) => id === icon.id)) {
        icons.push(icon)
      }

      return icons
    }, [])
  },

  /**
   * Reduce our Logo history into an Array of Palettes.
   */
  palettes: ({ logos }) => {
    return logos.reduce((palettes, { logo }) => {
      const palette = logo?.assets?.palette

      if (!!palette && !palettes.find(({ id }) => id === palette.id)) {
        palettes.push(palette)
      }

      return palettes
    }, [])
  },

  /**
   * Reduce our Logo history into an Array of Templates.
   */
  templates: ({ logos }) => {
    return logos.reduce((templates, { logo }) => {
      const template = logo?.assets?.template

      if (!!template && !templates.find(({ name }) => name === template.name)) {
        templates.push(template)
      }

      return templates
    }, [])
  },

  /**
   * Reduce our Logo history into an Array of Fonts.
   */
  fonts: ({ logos }) => {
    return logos.reduce((fonts, { logo }) => {
      const wordmark = logo?.assets?.slogan_fonts?.[0]
      const slogan = logo?.assets?.wordmark_fonts?.[0]

      if (!!wordmark && !fonts.find(({ id }) => id === wordmark.id)) {
        fonts.push(wordmark)
      }

      if (!!slogan && !fonts.find(({ id }) => id === slogan.id)) {
        fonts.push(slogan)
      }

      return fonts
    }, [])
  },
}
